// Ações puras do rébus — quatro campos, nenhuma coordenada.
//
// Regra do shell: quando uma ação não muda nada, devolver a MESMA referência do doc
// — é assim que o dirty tracking e o history sabem que nada aconteceu.

import type { RebusDoc } from './doc';

export type RebusAction =
  | { type: 'SET_TITULO'; titulo: string }
  | { type: 'SET_NUMERACAO'; numeracao: string }
  | { type: 'SET_SOLUCAO'; solucao: string }
  | { type: 'SET_IMAGEM'; imagem: string };

export function rebusReducer(doc: RebusDoc, action: RebusAction): RebusDoc {
  switch (action.type) {
    case 'SET_TITULO':
      return action.titulo === doc.titulo ? doc : { ...doc, titulo: action.titulo };

    case 'SET_NUMERACAO':
      return action.numeracao === doc.numeracao ? doc : { ...doc, numeracao: action.numeracao };

    case 'SET_SOLUCAO':
      return action.solucao === doc.solucao ? doc : { ...doc, solucao: action.solucao };

    case 'SET_IMAGEM':
      return action.imagem === doc.imagem ? doc : { ...doc, imagem: action.imagem };

    default:
      return doc;
  }
}

/**
 * Chave de coalescing do undo: ações contínuas com a mesma chave viram uma entrada
 * só. Cada campo de texto coalesce pelo PRÓPRIO nome — digitar a solução inteira é
 * um undo só, mas desfazer não volta para o meio do título.
 *
 * `SET_IMAGEM` nunca coalesce: não vem de digitação, e trocar a imagem é o tipo de
 * marco que o autor espera desfazer sozinho.
 */
export function coalesceKeyFor(action: RebusAction): string | null {
  switch (action.type) {
    case 'SET_TITULO':
      return 'titulo';
    case 'SET_NUMERACAO':
      return 'numeracao';
    case 'SET_SOLUCAO':
      return 'solucao';
    default:
      return null;
  }
}
